import { Grid } from '@material-ui/core';
import { Form, Formik } from 'formik';
import React from 'react';
import { toast } from 'react-toastify';
import { dateFormat } from 'v2/formatters/date';
import clearEmptyValues from 'v2/helpers/clearEmptyValues';
import webhookService from 'v2/services/webhook2';

import type { Webhook, WebhookHistoryFilter as IWebhookHistoryFilter } from 'v2/interfaces/webhook2';
import type { WebhookHistory } from 'v2/interfaces/webhook2';

import WebhookHistoricContext from './context';
import { FilterWebhookHistory } from './FilterWebhookHistory';
import { ListWebhookHistory } from './ListWebhookHistory';
import styles from '../styles';

import type IPagination from 'interfaces/IPagination';

type Props = {
  webhook: Webhook;
};

const today = dateFormat(new Date());

const initialFilter: IWebhookHistoryFilter = {
  date: [today, today],
  events: [],
  status: [],
};

export const History = ({ webhook }: Props) => {
  const { _id: id, type, product_id: productId } = webhook;
  const classes = styles();

  const [webhookHistory, setWebhookHistory] = React.useState<WebhookHistory[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [currentPagination, setCurrentPagination] = React.useState<IPagination>();
  const [filter, setFilter] = React.useState<Partial<IWebhookHistoryFilter>>();

  if (filter?.product_id?.length && filter?.product_id[0] === productId) {
    filter.product_id = [];
  }

  const getList = async (currentId: string, filter?: Partial<IWebhookHistoryFilter>, pg?: IPagination) => {
    try {
      setLoading(true);
      const { data, pagination } = await webhookService.historyList(currentId, filter, pg);
      setWebhookHistory(data);
      setLoading(false);
      setCurrentPagination(pagination);
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar histórico');
      setLoading(false);
    }
  };

  const updateList = async () => {
    setLoading(true);

    try {
      const { data, pagination } = await webhookService.historyList(id, filter, currentPagination);
      setWebhookHistory(data);
      setLoading(false);
      setCurrentPagination(pagination);
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar histórico');
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getList(id, initialFilter);
  }, [id]);

  const onSubmit = (values: IWebhookHistoryFilter) => {
    const filters = clearEmptyValues(values);
    setFilter(filters);
    getList(id, filters);
  };

  const changePagination = (pg: IPagination) => {
    getList(id, filter, pg);
  };

  const product_id = productId ? [productId] : [];
  const defaultValues: IWebhookHistoryFilter = { ...initialFilter, ...{ product_id } };

  return (
    <WebhookHistoricContext.Provider
      value={{
        webhook,
        listWebhookHistory: webhookHistory,
        updateList,
        pagination: currentPagination,
        setPagination: changePagination,
        loading,
        productId,
        type,
        id,
      }}
    >
      <Formik initialValues={defaultValues} onSubmit={onSubmit}>
        <Form>
          <Grid container spacing={2} justifyContent='flex-end' alignItems='center'>
            <Grid item xs={12} className={classes.filterHistoryExpanded}>
              <FilterWebhookHistory />
            </Grid>
          </Grid>
          <ListWebhookHistory />
        </Form>
      </Formik>
    </WebhookHistoricContext.Provider>
  );
};
